import React from 'react'
import { Button, Header, Icon, Modal, Segment, Form,  Dimmer, Table, Progress} from 'semantic-ui-react'


const ModalExamen = ({showModal, closeModal, modulos}) => (
    
  
    
  <Modal open={showModal}  size='large' >
  <Segment >
    
     <Modal.Content scrolling>
        
    {modulos!=null && modulos.length>0?

        <>
         {modulos.map(modulo =>
    
        <Segment attached>
             
    
        {modulo.contenidoView.map(rowView =>
         <Table  celled attached>
           
                <Table.Header>
                    <Table.Row>
                        <Table.HeaderCell colSpan='4'>{rowView.agrupador+" - "+rowView.fecha}</Table.HeaderCell>
                    </Table.Row>
                </Table.Header>
                            <Table.Body>
                                {rowView.contenido.map(row =>
                                      <Table.Row>
                                        
                                        

                                        <Table.Cell width="7">
                                            {row.desc+" "} 
                                            {row.icon=="video play"&&row.time!=null&&row.time>0?    
                                                <strong>
                                                visualizado  -{" "+Math.round(row.tiempoVideo/60)} min. de {Math.round(row.time/60)} min. aprx.
                                                </strong>
                                                :
                                                ""
                                            }
                                            {row.icon=="video play"?    
                                                <div>
                                                        {row.tiempoVideo==null?
                                                                ""
                                                            :   
                                                            <>    
                                                               {(row.time/60)<row.tiempoVideo?                    
                                                                 <Progress value={Math.round(row.tiempoVideo/60)} total={Math.round(Number(row.time/60))} success   />
                                                                :        
                                                                <Progress value={Math.round(row.tiempoVideo/60)} total={Math.round(Number(row.time/60))}  warning  />      
                                                                }
                                                            </>    
                                                        }
                                                </div>
                                            :
                                                "" 
                                            }
        
        
                        
                                            {row.idTipoContenido==28 && row.fechaInicioExamen!=null?
            
                                                <p>Activo el día: {row.fechaInicioExamen.substring(0,10)} al {row.fechaTerminoExamen.substring(0,10)}</p>                                    
                                                :
                                                ""
                                            }
            
                                        </Table.Cell>
                                        
                                        {row.visto==1?
                                            <Table.Cell width="1">

                                                <Icon color='green' name='checkmark' size='large' />

                                            </Table.Cell>

                                        :
                                            <Table.Cell width="1"> </Table.Cell>
                                        }
                                            
                                                    
                                     
                                        
                                      </Table.Row>
                                )}	
                            </Table.Body>
                        	
                        </Table>
                )}
         
               
                    
        </Segment>
        
            )}
        
        </>     
       
        :
        ""
        }
    
        
    </Modal.Content>

  

    
    
 
     <Modal.Actions>
        <Button  color='red' onClick={()=>closeModal(0)}>
            <Icon name='remove' /> Cerrar
        </Button>
      </Modal.Actions>
 </Segment>      
</Modal>
    
    
 
   
)

export default ModalExamen